import { useOutletContext, Navigate } from "react-router-dom";
import AgentManagement from "../../components/AgentManagement";

const AgentsPage = () => {
  const { agent } = useOutletContext();

  // Only tenant_admin can access this page (they manage their tenant's agents)
  if (agent?.role !== "tenant_admin") {
    return <Navigate to="/admin" replace />;
  }

  return (
    <div className="h-full overflow-y-auto p-6">
      <AgentManagement agent={agent} />
    </div>
  );
};

export default AgentsPage;
